module.exports = __webpack_public_path__ + "img/0.e1c20a68.png";